export default "__VITE_ASSET__QccdRptc__"